export default __webpack_public_path__ + "static/media/cart3.3e04e22f.jpg";